import { render, staticRenderFns } from "./BecomeModal.vue?vue&type=template&id=05009d79&"
import script from "./BecomeModal.vue?vue&type=script&lang=js&"
export * from "./BecomeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports